export const CONTENT_TYPES = {
  'icon-check': 'icon-check',
  'icon-minus': 'icon-minus',
  'icon-not-available': 'icon-not-available',
  text: 'text',
};
